import { render, staticRenderFns } from "./_OrganizationDetails.vue?vue&type=template&id=4ef29ed4&scoped=true&"
import script from "./_OrganizationDetails.vue?vue&type=script&lang=js&"
export * from "./_OrganizationDetails.vue?vue&type=script&lang=js&"
import style0 from "./_OrganizationDetails.vue?vue&type=style&index=0&id=4ef29ed4&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4ef29ed4",
  null
  
)

export default component.exports